.ux-iws-discontinuation-icon {
    display: inline-block;

    ux-icon {
        margin-right: 7px;
    }

    &__slot {
        display: none;
    }
}
